module.exports = __webpack_public_path__ + "media/images/gallery-image3-80a4c39a61414cfffe027f9e67c3a374.webp";